module.exports = __webpack_public_path__ + "img/result_txt_pp.57c5ca3b.png";